import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import { EEventStatus } from 'data/types/events.types';
import { Flex } from 'antd';
import { ChildOutline } from 'assets/icon/icon';
import { Text } from 'components/Base/Typography';
import { TProvidingProps } from './Providing.types';
import Childcare from './Childcare/Childcare';
import Food from './Food/Food';
import { providingKey } from './Providing.data';

const Providing: FC<TProvidingProps> = ({
  childcareProvided,
  foodProvided,
  id,
  eventStatus,
}) => {
  const needConfirmation = eventStatus === EEventStatus.PUBLISHED;
  const { t } = useTranslation({
    keyPrefix: providingKey,
  });

  return (
    <Flex align="center" gap={8}>
      <Flex align="center" gap={8} style={{ width: 160 }}>
        <ChildOutline size={24} />
        <Text color="#808080"> {t('LABEL')}</Text>
      </Flex>
      <Flex align="center" gap={8}>
        <Food
          foodProvided={foodProvided}
          id={id}
          needConfirmation={needConfirmation}
        />
        <Childcare
          id={id}
          childcareProvided={childcareProvided}
          needConfirmation={needConfirmation}
        />
      </Flex>
    </Flex>
    // <Row gutter={[8, 0]} align="middle" wrap={false}>
    //   <Col style={{ width: `${theme.inPlaceEditLabelMaxWidth}px` }}>
    //     <Paragraph
    //       fontSize={theme.inPlaceEditFontSize}
    //       color={theme.colorBlackGrey60}
    //       fontWeight={theme.inPlaceEditFontWeightLabel}
    //       fontFamily={theme.inPlaceEditFontFamily}
    //     >
    //       {t('LABEL')}
    //     </Paragraph>
    //   </Col>
    //   <Col>
    //     <Food
    //       foodProvided={foodProvided}
    //       id={id}
    //       needConfirmation={needConfirmation}
    //     />
    //   </Col>
    //   <Col>
    //     <Childcare
    //       id={id}
    //       childcareProvided={childcareProvided}
    //       needConfirmation={needConfirmation}
    //     />
    //   </Col>
    // </Row>
  );
};

export default Providing;
